import { FC, useCallback } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { Medication } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, CircularProgress, IconButton, TextField, Typography } from '@mui/material';
import cn from 'classnames';

import './style.scss';

interface IProps {
  className?: string;
  title: string;
  placeholder: string;
  showTitle?: boolean;
  isLoading: boolean;
  searchValue: string;
  onSearch: (value: string) => void;
  onKeyDown: (event: any) => void;
}

const HRSSearchInput: FC<IProps> = ({
  className,
  title,
  placeholder,
  showTitle = true,
  isLoading,
  searchValue,
  onSearch,
  onKeyDown,
}) => {
  const clearSearchValue = useCallback(() => {
    onSearch('');
  }, []);
  return (
    <Box className={cn('hrs-search-input', { 'hrs-search-input_no-frame': !showTitle }, className)}>
      {showTitle && (
        <Typography variant="h5" className="hrs-search-input__title">
          {title}
        </Typography>
      )}

      <DebounceInput
        className="hrs-search-input__input"
        minLength={3}
        debounceTimeout={400}
        onChange={(event: React.ChangeEvent<HTMLInputElement>): void =>
          onSearch(event.target.value)
        }
        onKeyDown={onKeyDown}
        element={TextField}
        placeholder={placeholder}
        value={searchValue}
        InputProps={{
          startAdornment: <Medication color={searchValue && !isLoading ? 'primary' : 'disabled'} />,
          endAdornment: (
            <>
              {isLoading && <CircularProgress color="primary" size={20} />}
              {searchValue && !isLoading && (
                <IconButton onClick={clearSearchValue}>
                  <CloseIcon />
                </IconButton>
              )}
            </>
          ),
        }}
      />
    </Box>
  );
};

export default HRSSearchInput;
